__turbopack_context__.v({
  "cityChip": "styles-module-scss-module__JBgc6G__cityChip",
  "cityList": "styles-module-scss-module__JBgc6G__cityList",
  "heading": "styles-module-scss-module__JBgc6G__heading",
  "icon": "styles-module-scss-module__JBgc6G__icon",
  "intro": "styles-module-scss-module__JBgc6G__intro",
  "root": "styles-module-scss-module__JBgc6G__root",
  "subHeading": "styles-module-scss-module__JBgc6G__subHeading",
});
